import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { usePoultryTransaction } from "@/hooks/poultry/usePoultryTransaction";
import { TransactionContent } from "./transaction/TransactionContent";

interface TransactionDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  transactionType: 'purchase' | 'sale';
  onSuccess: () => void;
}

export const TransactionDialog = ({
  isOpen,
  onOpenChange,
  transactionType,
  onSuccess
}: TransactionDialogProps) => {
  const {
    selectedPoultry,
    setSelectedPoultry,
    isCredit,
    setIsCredit,
    partialPayment,
    setPartialPayment,
    customerName,
    setCustomerName,
    customerContact,
    setCustomerContact,
    paymentDate,
    setPaymentDate,
    customerSignature,
    setCustomerSignature,
    customerAddress,
    setCustomerAddress,
    paymentMethod,
    setPaymentMethod,
    calculateTotal,
    handleAddTransaction,
  } = usePoultryTransaction(onSuccess);

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-hidden flex flex-col">
        <DialogHeader className="flex-shrink-0">
          <DialogTitle>
            {transactionType === 'purchase' ? 'Achat' : 'Vente'} de volailles
          </DialogTitle>
        </DialogHeader>

        <div className="flex-1 overflow-y-auto pr-2">
          <TransactionContent
            selectedPoultry={selectedPoultry}
            onPoultrySelect={setSelectedPoultry}
            isCredit={isCredit}
            onCreditChange={setIsCredit}
            partialPayment={partialPayment}
            onPartialPaymentChange={setPartialPayment}
            customerName={customerName}
            onCustomerNameChange={setCustomerName}
            customerContact={customerContact}
            onCustomerContactChange={setCustomerContact}
            paymentDate={paymentDate}
            onPaymentDateChange={setPaymentDate}
            customerSignature={customerSignature}
            onCustomerSignatureChange={setCustomerSignature}
            customerAddress={customerAddress}
            onCustomerAddressChange={setCustomerAddress}
            total={calculateTotal()}
            onConfirm={handleAddTransaction}
            onClose={() => onOpenChange(false)}
            paymentMethod={paymentMethod}
            onPaymentMethodChange={setPaymentMethod}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};